<template>
  <div class="cap-selector" :class="{ disabled }">
    <div class="label-box">
      <label>{{ title }}</label>
      <div class="input-select" @click="handleClick">
        <span class="selected-text">{{ selectedText }}</span>
        <i class="arrow-icon" :class="{ 'is-open': active }">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
            <path d="M1.31934 13.1987L7.31934 7.19873L1.31934 1.19873" stroke="#525252" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </i>
      </div>
    </div>

    <div v-if="active" class="selector">
      <button
        v-for="item in items"
        :key="item.value"
        class="option-btn"
        :class="{ active: selectedValue === item.value }"
        @click="selectOption(item)"
      >
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "CapSelector",
  props: {
    title: { type: String, default: "请选择" },
    items: { type: Array, default: () => [] },
    value: { type: [String, Number], default: "" },
    placeholder: { type: String, default: "请选择" },
    disabled: { type: Boolean, default: false },
    active: { type: Boolean, default: false } // 父组件控制展开
  },
  data() {
    return {
      selectedValue: this.value
    }
  },
  computed: {
    selectedText() {
      if (!this.selectedValue) return this.placeholder
      const item = this.items.find(i => i.value === this.selectedValue)
      return item ? item.label : this.placeholder
    }
  },
  watch: {
    value(newVal) { this.selectedValue = newVal }
  },
  methods: {
    handleClick() {
      if (!this.disabled) this.$emit("click")
    },
    selectOption(item) {
      this.selectedValue = item.value
      this.$emit("input", item.value)
      this.$emit("select", item)
      this.$emit("completed") // 通知父组件
    }
  }
}
</script>
<style lang="less" scoped>
.cap-selector {
  width: 100%;
    padding: 12px 0;
    border-bottom: 1px solid #eff6ff;
    &:last-child {
      border-bottom: none;
    }
  // 标签和输入区域
  .label-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    label {
      color: rgba(0, 0, 0, 0.6);
      font-family: "Source Han Sans CN";
      font-size: 15px;
      font-style: normal;
      font-weight: 350;
      line-height: 21px;
    }
    
    .input-select {
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      user-select: none;
      
      .selected-text {
        color: rgba(0, 0, 0, 0.7);
        font-family: "Source Han Sans CN";
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 21px;
        text-align: right;
      }
      
      .arrow-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.3s ease;
        
        &.is-open {
          transform: rotate(90deg);
        }
        
        svg {
          width: 9px;
          height: 14px;
        }
      }
    }
  }
  
  // 选项按钮组
  .selector {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
    animation: slideDown 0.3s ease;
    
    .option-btn {
      width: 98.2px;
      height: 32px;
      border: 1px solid #d9d9d9;
      border-radius: 16px;
      background: #fff;
      font-family: "Source_Han_Sans_CN", sans-serif;
      font-weight: 500;
      font-size: 15px;
      color: #959595;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      white-space: nowrap;
      
      &:hover {
        border-color: #254774;
        color: #254774;
      }
      
      &.active {
        background: #254774;
        border-color: #254774;
        color: #fff;
      }
      
      &:active {
        transform: scale(0.98);
      }
    }
  }
}

// 展开动画
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 禁用状态
.cap-selector.disabled {
  .input-select {
    cursor: not-allowed;
    opacity: 0.6;
  }
  
  .option-btn {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>

